import { getShopperId } from '../util/auth';
import { trackPaymentDetailsGetError } from './newRelicTrackingApi';
import { dispatchGetRequest } from '../util/apiUtils';
import { Amount, Payment } from '../types/paymentsTypes';

const prodWebBaseUrl = process.env.PRD_PAYMENT_WEB_BASE_URL;
const stagingWebBaseUrl = process.env.STG_PAYMENT_WEB_BASE_URL;

type PaymentDetailsResponse = {
  payments: Payment[];
  totalCaptured: Amount;
  totalDebits: Amount;
  totalRemaining: Amount;
};

type PaymentDetailsRequest = {
  environment: string;
  orderId: string;
};

export const getPaymentDetails = async ({
  environment,
  orderId,
}: PaymentDetailsRequest): Promise<Payment[]> => {
  const shopperId = getShopperId();
  const baseUrl =
    environment === 'PRODUCTION' ? prodWebBaseUrl : stagingWebBaseUrl;
  const url = `${baseUrl}/api/v1/Payments/forOrder/${orderId}`;

  try {
    const response = await dispatchGetRequest({ url });
    const { payments } = (await response.json()) as PaymentDetailsResponse;
    return payments;
  } catch (err) {
    trackPaymentDetailsGetError(err, shopperId);
    // TODO: include om-newrelic-tracker here in a follow-up MR
    throw err;
  }
};
